import React, { createContext, useContext } from 'react';
export const PageTitleContext = createContext({ appBaseTitle: '' });
export const PageTitleProvider = ({ appBaseTitle, children }) => {
    return (React.createElement(PageTitleContext.Provider, { value: {
            appBaseTitle,
        } }, children));
};
export const usePageTitleContext = () => useContext(PageTitleContext);
//# sourceMappingURL=PageTitleContext.js.map